import React from "react";
import * as crossfilter from "crossfilter2";
import {csv,timeFormat,timeParse,timeMonth,format} from 'd3';
import * as dc from "dc";
import "dc/dc.css";
//import data from './databw4.csv';

export const CXContext = React.createContext("CXContext");
export const  dateFormatSpecifier = '%m/%d/%Y %H:%M';
export const dateFormat = timeFormat(dateFormatSpecifier);
export const dateFormatParser = timeParse(dateFormatSpecifier);
export const numberFormat = format('.2f');

const data = 'https://baloka.com/BoomWriter/databw4.csv';


const tags = []
export class DataContext extends React.Component {
  constructor(props) {
    super(props);
    this.state={loading:false,hasNDX:false};
  }

  componentDidMount(){
      if (this.state.hasNDX){
          return
      }
      if(this.state.loading){
          return
      }
      this.setState({loading:true})

      //  self = this;

      //csv('https://lighttag.github.io/dcjs-in-react/ndx.csv')
      //'http://twnelwebsite.azurewebsites.net/fakedata/data.csv'
      let l = 0;
      let years = [];
      let tot_words = 0;

      csv(data)
        .then((data)=> {
            data.forEach(function (d) {
              d.date = new Date(d.date);
              d.day = +d.date.getDay();
              d.dsubmissiom = new Date(d.submission_date);
              d.year = d.dsubmissiom.getFullYear();
              d.n_of_words = +d.n_of_words;
              d.vocabulary_used = +d.vocabulary_used;
              d.years = [];
              if(d.years.indexOf(d.year) == -1) {
                   d.years.push(d.year);
               }

              tot_words += d.n_of_words;
              // d.n_of_words = +d.n_of_words;
               d.grading_score = +d.grading_score;
               d.slevel = +0;
               if(d.grading_score < 2) {
                 d.s_level = '0 - 2';
                 d.slevel = +1;
               }
               else if(d.grading_score > 2 && d.grading_score <= 2.2) d.s_level = '2 - 2.2';
               else if(d.grading_score > 2.2 && d.grading_score <= 2.4) d.s_level = '2.2 - 2.4';
               else if(d.grading_score > 2.4 && d.grading_score <= 2.6) d.s_level = '2.4 - 2.6';
               else if(d.grading_score > 2.6 && d.grading_score <= 2.8) d.s_level = '2.6 - 2.8';
               else if(d.grading_score > 2.8 && d.grading_score <= 3) d.s_level = '2.8 - 3';
               else if(d.grading_score > 3 && d.grading_score <= 3.2) d.s_level = '3 - 3.2';
               else if(d.grading_score > 3.2 && d.grading_score <= 3.4) d.s_level = '3.2 - 3.4';
               else if(d.grading_score > 3.4 && d.grading_score <= 3.6) d.s_level = '3.4 - 3.6';
               else if(d.grading_score > 3.64 && d.grading_score <= 3.8) d.s_level = '3.6 - 3.8';
               else  d.s_level = '3.8 - 4';

               d.teacher_name = d.teacher + d.teacher_id;
               //d.teacher_name[d.teacher_id] = d.teacher;
               //d[d.teacher_id] = d.teacher;
               //d.counter = 1;


                // d.dincoming = new Date(d.incoming_time);
                // d.dreserved = new Date(d.reserved_time);
                // d.dclosed = new Date(d.closed_time);
                // d.wait_time = parseFloat((d.dreserved - d.dincoming)/60000);
                // d.conversation_time = parseFloat((d.dclosed - d.dincoming)/60000);   //d.dclosed - d.dreserved;
                // d.day = +d.dincoming.getDay();
                // d.hour = +d.dincoming.getHours();
                // d.slevel = +0;
                // if(d.wait_time <= 30) {
                //   d.s_level = '<= 30 secs';
                //   d.slevel = +1;
                // }
                // else if(d.wait_time > 30 && d.wait_time <= 60) d.s_level = '30+ - 60 secs';
                // else if(d.wait_time > 60 && d.wait_time <= 120) d.s_level = '60+ - 120 secs';
                // else if(d.wait_time > 120 && d.wait_time <= 180) d.s_level = '120+ - 180 secs';
                // else  d.s_level = '> 3 minutes';
                // d.tags = d.tags.split(",");
                // d.tag = [];
                // for(var i=0; i<20; i++){
                //   d.tag.push('');
                // }
                //
                // for(i=0; i<d.tags.length; i++) {
                //   if(d.tags[i] != ' '){
                //     if(tags.indexOf(d.tags[i]) == -1) {
                //         tags.push(d.tags[i])
                //     }
                //
                //     const index = tags.indexOf(d.tags[i]);
                //     d.tag[index] = d.tags[i];
                //   }
                // }
            });

            //this.tags = tags;
            console.log(data);
            console.log("tot_words "+tot_words);

            this.ndx = crossfilter(data); //TODO possibly need to update this

            this.setState({loading:false,hasNDX:true});
        })
  }

  render() {
      if(!this.state.hasNDX){
          return null;
      }
    return (
      <div>
        <div ref={(el) => { this.datanumber = el; }}> </div>
        <CXContext.Provider value={{ndx:this.ndx,  index:''}}>
          <div ref={this.parent} >
          {this.props.children}
          </div>
        </CXContext.Provider>
      </div>
    );
  }
}
